export default __webpack_public_path__ + "static/media/1_0032.85b8ff77.webp";